// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cart_cartDrop__hphO- {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.23);
    position: fixed;
    top: 0;
    left: 0;
    pointer-events: auto;
}

.cart_cart__Vk8Bs {
    background-color: #FFFFFF;
    width: 420px;
    height: 100%;
    right: 0;
    position: fixed;
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
}

.cart_cartHeader__ryIJs {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: #C7CDD4 1px solid;
}

.cart_cartFooter__Y70ch {
    text-align: left;
    display: flex;
    flex-direction: column;
    margin-top: auto;
    -webkit-user-select: none;
            user-select: none;
}

.cart_orderButton__EKIj0 {
    background-color: var(--global-main-color);
    border-radius: 40px;
    color: #FFFFFF;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
}

.cart_buttonPrice__A-dbf {
    align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: column;
    background-color: #FFFFFF;
    color: var(--global-main-color);
    border-radius: 40px;
}

.cart_quantitySelector__bjV4e {
    background-color: #eeeeee;
    border-radius: 20px;
}

@media (min-width: 650px) {
    .cart_container__p5N5r {
        position: fixed;
        right: 0;
        height: 100%;
        -webkit-user-select: none;
                user-select: none;
        pointer-events: none;
    }

    .cart_cartMini__ERT5J {
        display: flex;
        justify-content: center;
        flex-direction: column;
    }
}

@media (max-width: 650px) {
    .cart_container__p5N5r {
        position: fixed;
        width: 100%;
        flex-direction: column;
        justify-content: end;
        height: 100%;
        pointer-events: none;
    }

    .cart_cartMini__ERT5J {
        display: flex;
        justify-content: center;
        margin-bottom: 30px;
    }

    .cart_cart__Vk8Bs {
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/shop/components/cart/cart.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,qCAAqC;IACrC,eAAe;IACf,MAAM;IACN,OAAO;IACP,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,QAAQ;IACR,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,0CAA0C;IAC1C,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,+BAA+B;IAC/B,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI;QACI,eAAe;QACf,QAAQ;QACR,YAAY;QACZ,yBAAiB;gBAAjB,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,eAAe;QACf,WAAW;QACX,sBAAsB;QACtB,oBAAoB;QACpB,YAAY;QACZ,oBAAoB;IACxB;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[".cartDrop {\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.23);\n    position: fixed;\n    top: 0;\n    left: 0;\n    pointer-events: auto;\n}\n\n.cart {\n    background-color: #FFFFFF;\n    width: 420px;\n    height: 100%;\n    right: 0;\n    position: fixed;\n    display: flex;\n    flex-direction: column;\n    overflow-y: scroll;\n}\n\n.cartHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: #C7CDD4 1px solid;\n}\n\n.cartFooter {\n    text-align: left;\n    display: flex;\n    flex-direction: column;\n    margin-top: auto;\n    user-select: none;\n}\n\n.orderButton {\n    background-color: var(--global-main-color);\n    border-radius: 40px;\n    color: #FFFFFF;\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    cursor: pointer;\n}\n\n.buttonPrice {\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    flex-direction: column;\n    background-color: #FFFFFF;\n    color: var(--global-main-color);\n    border-radius: 40px;\n}\n\n.quantitySelector {\n    background-color: #eeeeee;\n    border-radius: 20px;\n}\n\n@media (min-width: 650px) {\n    .container {\n        position: fixed;\n        right: 0;\n        height: 100%;\n        user-select: none;\n        pointer-events: none;\n    }\n\n    .cartMini {\n        display: flex;\n        justify-content: center;\n        flex-direction: column;\n    }\n}\n\n@media (max-width: 650px) {\n    .container {\n        position: fixed;\n        width: 100%;\n        flex-direction: column;\n        justify-content: end;\n        height: 100%;\n        pointer-events: none;\n    }\n\n    .cartMini {\n        display: flex;\n        justify-content: center;\n        margin-bottom: 30px;\n    }\n\n    .cart {\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cartDrop": `cart_cartDrop__hphO-`,
	"cart": `cart_cart__Vk8Bs`,
	"cartHeader": `cart_cartHeader__ryIJs`,
	"cartFooter": `cart_cartFooter__Y70ch`,
	"orderButton": `cart_orderButton__EKIj0`,
	"buttonPrice": `cart_buttonPrice__A-dbf`,
	"quantitySelector": `cart_quantitySelector__bjV4e`,
	"container": `cart_container__p5N5r`,
	"cartMini": `cart_cartMini__ERT5J`
};
export default ___CSS_LOADER_EXPORT___;
